import * as Y from 'yjs'

const preparedPageDocs = new Map<string, Y.Doc>()
const pageDocs = new Map<string, Y.Doc>()

/**
 * Makes a fully initialized page document available to the app's page-binding
 * layer before activePageId changes.
 */
export function preparePageYdoc(pageId: string, ydoc: Y.Doc): void {
  preparedPageDocs.set(pageId, ydoc)
}

function takePreparedPageYdoc(pageId: string): Y.Doc | null {
  const ydoc = preparedPageDocs.get(pageId) || null
  preparedPageDocs.delete(pageId)
  return ydoc
}

/**
 * The one Y.Doc for a page in this app session. The editor binding and
 * background edits (find and replace) must share it: the sync engine keys
 * providers by page id, so a second Y.Doc for the same page would fork it.
 */
export function getPageYdoc(pageId: string): Y.Doc {
  let pageDoc = pageDocs.get(pageId)
  if (!pageDoc) {
    pageDoc = takePreparedPageYdoc(pageId) || new Y.Doc()
    pageDocs.set(pageId, pageDoc)
  }
  return pageDoc
}

/** Empties the registry and returns every document it held, for teardown. */
export function releasePageYdocs(): Y.Doc[] {
  const docs = [...pageDocs.values()]
  pageDocs.clear()
  return docs
}

export function pageIdForYdoc(doc: Y.Doc): string | null {
  for (const [pageId, pageDoc] of pageDocs) if (pageDoc === doc) return pageId
  return null
}
